"use client"

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useTranslations } from "next-intl"


interface RawCallDataDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  callId: string
  rawData: unknown
}

export function RawCallDataDialog({ open, onOpenChange, callId, rawData }: RawCallDataDialogProps) {
  const tUi = useTranslations("Calls.CallsRawCallDataDialog")

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex max-w-3xl flex-col overflow-hidden pb-6">
        <DialogHeader className="shrink-0 pr-6">
          <DialogTitle><span key={tUi("rawCallData")}>{tUi("rawCallData")}</span></DialogTitle>
          <DialogDescription className="break-all"><span><span key={tUi("storedDataForCall")}>{tUi("storedDataForCall")}</span></span> {callId}<span>.</span></DialogDescription>
        </DialogHeader>
        <div className="min-h-0 overflow-y-auto overscroll-contain">
          {rawData == null ? (
            <p className="py-6 text-sm text-muted-foreground"><span key={tUi("noRawDataIsAvailableForThisCall")}>{tUi("noRawDataIsAvailableForThisCall")}</span></p>
          ) : (
            <pre className="whitespace-pre-wrap break-words rounded-md bg-muted p-3 text-xs [overflow-wrap:anywhere]">
              {JSON.stringify(rawData, null, 2)}
            </pre>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
